var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1WHair5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair5_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M486.5,46.1c-4.2-1.6-8.5-3.1-12.7-4.5c-6.4-2-12.9-3.8-19.4-5.3s-13-3-19.4-4.4 c-44.4-7.5-88.4-7.5-132.5,0.6c-5.7,1.1-11.3,2.3-16.8,3.7c-51.1,13.1-104.1,44.1-123.5,95.6c-1.7,4.5-3,9.2-4,13.8 c-4,18.6-2.2,37.7,8.3,54.1c0,0.3,0,0.7,0.1,1c19.9,26.2,47.9,46.6,80.4,54.3c0.2-0.1,0.4-0.2,0.6-0.3 c-22.9-25.2-26.6-60.2-14.1-82h0.1c28.1-9.3,60.3-16.1,106-20l87.5,2.5c18.5-0.4,33,3.2,44.6,9.1l-9.1,6.4 c32.7,16.2,46.8,58.7,35.5,96c6.1-6.6,14-16.9,20.9-28.1c9.6-11.4,21.5-29,27-42.9c1.9-4.8,3.5-9.6,4.9-14.6 C569.5,128.5,541.5,63.5,486.5,46.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_5_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M501.8,176.7l-0.8-17.3c-1.2-15.8-0.6-18.6-7.2-20.9c-1.2-0.4-2.5-0.8-3.8-1.3 c-18.6-6.2-38-10.7-57.8-13.7c-3.5-0.5-7.1-1-10.6-1.5c-28.9-4.8-58.6-7.1-88.6-6.1c-3.8,0.1-7.5,0.3-11.3,0.5 c-32.7,2.2-65.1,7.7-94.8,19.2c-1.4,0.5-2.8,1.1-4.1,1.6c-3,1.2-10.8-0.1-4.9,48.4l0.1,3.5c1.4,9.6,6,11.4,10.7,9.8 c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9c14.7-4.2,29.7-7.4,44.9-9.7c7.6-1.2,15.3-2.1,23.1-2.8c36.4-3,72.6-3,108.2,0.6 c7.1,0.7,14.2,1.5,21.2,2.6c13.8,2.1,27.5,4.9,40.8,8.5C488,199.6,503.5,206.9,501.8,176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M333,116c30-1,59.7,1.3,88.6,6.1c3.5,0.5,7.1,0.9,10.6,1.5c19.8,3,39.2,7.5,57.8,13.7 c0.1-2.6,0.2-5.3,0.1-7.9c-0.1-3.4-0.3-6.7-0.8-10c-3.1-24.3-14.8-49.7-35.6-67.1c-3-2.5-6.1-4.8-9.4-6.9 c-17.6-11.8-38.9-16.5-60.9-17.7c-3.7-0.2-7.4-0.3-11-0.3c-39,0.4-82.2,4.4-111.4,28.9c-3.1,2.4-5.9,5-8.6,7.6 c-19.3,19.6-26.7,45.9-25.4,71.9c29.7-11.4,62.1-17,94.8-19.2C325.5,116.3,329.3,116.1,333,116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M485.3,132.6c-2.5-1-5.1-2.1-7.7-3.1c-17.3-6.6-35.2-11.9-53.7-15.9c-3.7-0.8-7.4-1.6-11.1-2.3 c-40.9-7.9-82.9-8.9-124.2-4.3c-3.7,0.4-7.5,0.9-11.1,1.5c-7.4,1.2-14.6,2.7-21.7,4.7c3.6-31.6,23-61.5,53-79.5 c0.2-0.1,0.3-0.2,0.5-0.3c-17.9,4.2-34.6,11.2-48.3,22.7c-3.1,2.4-5.9,5-8.6,7.6c-19.3,19.6-26.7,45.9-25.4,71.9 c29.7-11.4,62.1-17,94.8-19.2c3.8-0.2,7.5-0.4,11.3-0.5c30-1,59.7,1.3,88.6,6.1c3.5,0.5,7.1,0.9,10.6,1.5 c19.8,3,39.2,7.5,57.8,13.7c0-0.8,0.1-1.7,0.1-2.5C488.5,134,486.9,133.3,485.3,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M246.5,174.4c6.8-14.6,14.8-29.8,8.3-47.6c-9.5,2.5-18.7,5.4-27.8,8.9c-1.4,0.5-2.8,1.1-4.1,1.6 c-3,1.2-10.8-0.1-4.9,48.4l0.1,3.5c1.4,9.6,6,11.4,10.7,9.8c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9c5-1.4,10-2.7,15-3.9 C248.1,186.7,244.3,180,246.5,174.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M362.5,16.7c-12-6.5-25.9,1.7-28.3,12.6c11.5-1.3,23.1-1.8,34.4-2C368,23.2,366.8,18.9,362.5,16.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M321,119.8c3.8-0.2,7.5-0.4,11.3-0.5c30-1,59.7,1.3,88.6,6.1c3.5,0.5,7.1,0.9,10.6,1.5 c23.4,3.5,46.4,9.2,68,17.3c-0.8-3.2-2.3-4.5-5.7-5.7c-1.2-0.4-2.5-0.8-3.8-1.3c-6.9-2.3-13.8-4.3-20.9-6.2l-0.3-7.3 C465,91.8,452.1,65,427.1,42.2c24.8,23.1,35.4,50.5,38.9,81.7l0.3,6.4c-11.2-2.8-22.5-5.1-34-6.8l-0.7-6.7 c-4.3-30.4-14.8-55.5-32-81.3c16.9,26.1,25.1,51.6,29.2,81.6l0.7,6.1c-2.6-0.4-5.3-0.7-7.9-1.1c-10.1-1.7-20.2-3-30.4-4.1 l-0.3-6.3c-1.7-28-3.4-52.3-13.8-78.4c10.1,26.3,9.5,50.6,11.1,78.5l0.3,5.9c-10.5-1-21.1-1.6-31.8-1.9v-6 c-0.2-26.9-2.6-49.7-7-75.6c3.9,26,4.1,48.9,4.2,75.6v5.9c-7-0.1-13.9-0.1-20.9,0.2c-3.8,0.1-7.5,0.3-11.3,0.5 c-1.5,0.1-2.9,0.2-4.3,0.3l-0.5-5.4c-1.9-26.6-2.1-50.1,9.1-74.8c-11.5,24.5-13.6,48.1-11.8,75c0.1,1.9,0.3,3.7,0.5,5.5 c-11.6,1-23,2.4-34.4,4.3c-0.3-1.7-0.7-3.4-0.9-5.2c-2.7-24.8,0.8-46.9,11.4-69.9c-11,22.8-16.8,44.6-14.2,70.1 c0.2,1.8,0.6,3.6,0.9,5.4c-7.7,1.4-15.3,3-22.8,5c-0.2-1.5-0.5-3.1-0.6-4.6c-1.7-22.9,2.4-42.7,10.4-64.3 c-8.3,21.4-14.8,40.9-13.2,64.5c0.1,1.8,0.4,3.5,0.7,5.2c-8.5,2.3-16.9,5-25.1,8.1c-1.4,0.5-2.8,1.1-4.1,1.6 c-1.4,0.6-3.8,0.6-5.4,5.3c3.2-1.4,6.5-2.7,9.8-4C256.6,127.4,288.6,122,321,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M412.5,180.7c-35.6-3.6-71.8-3.6-108.2-0.6c-7.8,0.7-15.5,1.7-23.1,2.8c-15.3,2.3-30.2,5.5-44.9,9.7 c-2.4,0.7-4.8,1.4-7.1,2.2c-2.6,0.9-5.1,1.8-7.6,2.8c2,1.9,4.6,2.1,7.2,1.2c0.4-0.1,0.7-0.2,1.1-0.4c2-0.7,4-1.3,6-1.9 c14.7-4.2,29.7-7.4,45-9.7c7.6-1.2,15.3-2.1,23.1-2.8c36.4-3,72.6-3,108.2,0.6c7.1,0.7,14.2,1.5,21.2,2.6 c13.8,2.1,27.5,4.9,40.8,8.5c7.7,2.1,15.9,5.3,21.4,2.5c-19.8-6.9-40.6-11.8-61.8-15C426.7,182.3,419.7,181.4,412.5,180.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M245.9,187.3c-7.2-16.6-5.9-31.8-4.9-48.4c-0.4,16.7,1.7,31.5,8.7,47.1l2,4.1l-3.7,1.5L245.9,187.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M272.3,181.8c-5.8-17-6.9-32.2-4.4-49.1c-1.9,17,2.6,31.8,8.3,48c0.5,1.5,1.2,2.9,1.8,4.3l-3.8,1.3 C273.5,184.8,272.8,183.3,272.3,181.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M302.8,177.8c-4.1-17.3-5.7-32.4-5-49.6c-0.1,17.2,4.7,31.8,8.9,48.8l1.2,4.6l-3.9,0.8L302.8,177.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M336,175.6c-3.4-17.8-1.5-33.1,1.1-50.2c-2,17.2-0.6,32.4,2.9,49.5l1,4.6l-3.9,0.7L336,175.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M370.6,175.1c3-17.6,5.4-32.8,3.3-50.3c2.6,17.4,3.6,32.9,0.7,50.8l-0.8,4.8l-4-0.6L370.6,175.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M408.9,177.9c4.2-17.1,6.2-32.5,2.4-49.7c4.3,17,5.7,32.7,1.5,50.5l-1.3,4.7l-3.9-0.9L408.9,177.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M446.4,183.4c2.8-16.4,4.1-30.8,0.7-47.1c4,16,6,30.7,3.3,47.6l-0.9,4.5l-4-0.6L446.4,183.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M473.5,188.6c3.7-15.9,6.6-29.8,5.2-45.9c2,15.9,2.5,30.2-1.2,46.6l-1.1,4.3l-3.9-0.8L473.5,188.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M311.8,41c-0.4,1.6-1.4,2.8-2.4,2.7c-0.9-0.2-1.4-1.6-1.1-3.2c0.4-1.6,1.4-2.8,2.4-2.7 C311.6,38,312.1,39.4,311.8,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M302.3,65.4c-0.3,1.3-1.2,2.3-2,2.2c-0.8-0.1-1.2-1.3-0.9-2.7s1.2-2.3,2-2.2 C302.2,62.9,302.6,64.1,302.3,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M265.8,94.8c-0.3,1.3-1.2,2.3-2,2.2c-0.8-0.1-1.2-1.3-0.9-2.7c0.3-1.3,1.2-2.3,2-2.2 C265.7,92.3,266.1,93.5,265.8,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M260.1,173.2c0,1.4-0.6,2.5-1.4,2.5s-1.5-1.1-1.5-2.4c0-1.4,0.6-2.5,1.4-2.5S260.1,171.8,260.1,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M288.7,132.3c0.1,1.6-0.7,3-1.6,3s-1.8-1.3-1.8-2.9c-0.1-1.6,0.7-3,1.6-3 C287.9,129.3,288.7,130.6,288.7,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M286.1,170.6c0.4,1.6,0,3-1,3.2c-0.9,0.2-2-1-2.4-2.6s0-3,1-3.2C284.6,167.9,285.7,169.1,286.1,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M317.3,152.3c0.3,1.6-0.3,3-1.2,3.1c-0.9,0.1-1.9-1.1-2.2-2.7c-0.3-1.6,0.3-3,1.2-3.1 S317,150.7,317.3,152.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M328.1,126.4c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9S328.1,124.7,328.1,126.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M355.2,129.8c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9 C354.5,126.9,355.2,128.2,355.2,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M350.8,167.2c0,1.6-0.8,2.9-1.8,2.9c-0.9,0-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9 C350.1,164.3,350.9,165.6,350.8,167.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M391.7,141.6c0,1.6-0.8,2.9-1.8,2.9s-1.7-1.3-1.7-3c0-1.6,0.8-2.9,1.8-2.9S391.7,139.9,391.7,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M396,169.9c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.2-3.1s1.2-2.8,2.2-2.7 C395.7,166.9,396.3,168.3,396,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M435.4,163.9c-0.3,1.6-1.2,2.8-2.2,2.7c-0.9-0.1-1.5-1.5-1.2-3.1s1.2-2.8,2.2-2.7 C435.1,160.9,435.7,162.3,435.4,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M462.5,146.8c0,1.6-0.8,2.9-1.7,2.9c-0.9,0-1.7-1.3-1.7-2.9c0-1.6,0.7-2.9,1.7-2.9 C461.8,143.8,462.5,145.1,462.5,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M464.9,179c-0.1,1.6-1,2.9-2,2.8c-0.9-0.1-1.6-1.4-1.5-3s1-2.9,2-2.8C464.4,176,465,177.4,464.9,179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M490.4,150c0,2-1,3.7-2.2,3.6c-1.2,0-2.1-1.7-2.1-3.7s1-3.7,2.2-3.6S490.4,148,490.4,150z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M294.6,94.3c-0.2,1.4-1.1,2.5-1.9,2.4s-1.3-1.3-1.1-2.7c0.2-1.4,1.1-2.5,1.9-2.4 C294.4,91.6,294.9,92.9,294.6,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M275.5,57c-0.8,1.7-2.2,2.8-3.2,2.5s-1.1-2-0.4-3.7c0.8-1.7,2.2-2.8,3.2-2.5S276.3,55.3,275.5,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M247,93.8c-0.5,1.8-1.7,3-2.8,2.8c-1-0.2-1.5-1.8-1-3.6c0.5-1.8,1.7-3,2.8-2.8 C247,90.4,247.5,92,247,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M239.3,116.6c-0.1,1.8-1,3.3-2,3.3c-1.1,0-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2-3.3 C238.5,113.2,239.3,114.7,239.3,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M229.5,164.9c-0.1,1.8-1,3.3-2,3.3c-1.1,0-1.9-1.5-1.8-3.3c0.1-1.8,1-3.3,2-3.3 C228.8,161.6,229.6,163.1,229.5,164.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M254,147.6c-0.1,1.6-0.9,3-1.8,2.9c-1,0-1.7-1.4-1.6-3c0.1-1.6,0.9-3,1.8-2.9 C253.4,144.6,254.1,146,254,147.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M230.2,188.5c0.3,1.4-0.1,2.7-0.9,2.8c-0.8,0.1-1.7-0.9-2-2.3c-0.3-1.4,0.1-2.7,0.9-2.8 C229,186,229.9,187.1,230.2,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M333.6,56c0,1.4-0.7,2.6-1.5,2.6c-0.9,0-1.6-1.1-1.6-2.6c0-1.4,0.7-2.6,1.5-2.6S333.6,54.6,333.6,56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M331.4,94.3c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.6-2.6 C330.8,91.7,331.5,92.8,331.4,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M366.8,54.2c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6c0-1.4,0.8-2.6,1.6-2.6 C366.2,51.6,366.8,52.8,366.8,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M369.9,76.2c0,1.4-0.8,2.6-1.6,2.6c-0.9,0-1.5-1.2-1.5-2.6s0.8-2.6,1.6-2.6 C369.3,73.6,370,74.7,369.9,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M396.8,52c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.1-2.7 C395.7,49.5,396.5,50.6,396.8,52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M405.1,95.7c0.2,1.4-0.3,2.6-1.1,2.7c-0.9,0.1-1.7-1-1.9-2.4c-0.2-1.4,0.3-2.6,1.2-2.7 C404,93.3,404.9,94.3,405.1,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M432.5,69.8c0.5,1.4,0.1,2.7-0.7,2.9c-0.8,0.2-1.9-0.8-2.3-2.1c-0.5-1.4-0.1-2.7,0.7-2.9 C431,67.5,432,68.4,432.5,69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M448.6,103.6c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.8-0.8-2.2-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C447.2,101.2,448.2,102.2,448.6,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M469.4,82.1c0.4,1.4,0.1,2.7-0.8,2.8c-0.8,0.2-1.8-0.8-2.3-2.2c-0.4-1.4-0.1-2.7,0.8-2.8 C468,79.8,469,80.7,469.4,82.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1WHair5);
export default __webpack_public_path__ + "static/media/m-hat1_w-hair5.5e04a829647687b4124daf8efdcf8fdc.svg";
export { ForwardRef as ReactComponent };